/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react';
import type { AppProps } from 'next/app';
import Router from 'next/router';
import NProgress from 'nprogress'; //nprogress module

import '../styles/global.css';
// Load fontawesome styles
import '@fortawesome/fontawesome-svg-core/styles.css';

// Load tooltip styles
import 'react-tooltip/dist/react-tooltip.css';

// nprogress styles
import 'nprogress/nprogress.css';

// Skeleton styles
import 'react-loading-skeleton/dist/skeleton.css';

// Lightbox
import 'react-awesome-lightbox/build/style.css';
import { nunito } from '../styles/font';

// Route events
Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

/**
 * Root component.
 */
export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <div className={nunito.className}>
      {/* Redundantly adding here to ensure third party scripts have Nunito */}
      <style jsx global>{`
        html {
          font-family: ${nunito.style.fontFamily};
        }
      `}</style>
      <Component {...pageProps} />
    </div>
  );
}
